const aceApi: string = process.env.REACT_APP_ACE_API;
const avatarApi: string = process.env.REACT_APP_AVATAR_API;
const pactSafeAccessId: string = process.env.REACT_APP_PACT_SAFE_ACCESS_ID;
const pactSafeGroupId: string = process.env.REACT_APP_PACT_SAFE_GROUP_ID;
const pactSafeGroupKey: string = process.env.REACT_APP_PACT_SAFE_GROUP_KEY;
const pactSafeSnapshotId: string = process.env.REACT_APP_PACT_SAFE_SNAPSHOT_ID;
const pactSafeUpgradeGroupKey: string = process.env.REACT_APP_PACT_SAFE_UPGRADE_GROUP_KEY;
const pactSafeUpgradeGroupId: string = process.env.REACT_APP_PACT_SAFE_UPGRADE_GROUP_ID;
const pactSafeUpgradeSnapshotId: string = process.env.REACT_APP_PACT_SAFE_UPGRADE_SNAPSHOT_ID;
const customizeEndpoint: string = process.env.REACT_APP_CUSTOMIZE_API;
const localizationEndpoint: string = process.env.REACT_APP_LOCALIZATION_API;
const growthApi: string = process.env.REACT_APP_GROWTH_API;
const hostname: string = process.env.REACT_APP_HOSTNAME;
const erosURL: string = process.env.REACT_APP_EROS_S3_URL;
const apiURL: string = process.env.REACT_APP_API_URL;
const optimizely: string = process.env.REACT_APP_OPTIMIZELY_FRONT_END_SDK_KEY;
const segment: string = process.env.REACT_APP_SEGMENT;
const abTestPath: string = process.env.REACT_APP_AB_TEST_PATH;
const abTestGwpId: string = process.env.REACT_APP_AB_TEST_GWP_ID;
const abTestGwpVariantAId: string = process.env.REACT_APP_AB_TEST_GWP_VARIANT_A_ID;
const abTestGwpVariantBId: string = process.env.REACT_APP_AB_TEST_GWP_VARIANT_B_ID;
const recurlyPublicKey = process.env.REACT_APP_RECURLY_PUBLIC_KEY;
const revenueApi = process.env.REACT_APP_REVENUE_API;
const invitationApi = process.env.REACT_APP_INVITATION_API;
const registerApi = process.env.REACT_APP_REGISTER_API;
const userEndpoint: string = process.env.REACT_APP_USER_API;
const myAccountApi: string = process.env.REACT_APP_MY_ACCOUNT_API;
const universalNavigationApi: string = process.env.REACT_APP_UNIVERSAL_NAVIGATION_API;
const questionnaireApi = process.env.REACT_APP_QUESTIONNAIRE_API;
const hCaptchaSiteKey: string = process.env.REACT_APP_HCAPTCHA_SITEKEY;
const loginUrl = process.env.REACT_APP_LOGIN_URL;
const appEnv = process.env.REACT_APP_ENVIRONMENT;

const envValues = {
  aceApi,
  user: userEndpoint,
  customize: customizeEndpoint,
  avatarApi,
  localization: localizationEndpoint,
  growth: growthApi,
  hostname,
  erosURL,
  apiURL,
  optimizely,
  segment,
  abTestPath,
  abTestGwpId,
  abTestGwpVariantAId,
  abTestGwpVariantBId,
  appEnv,
  recurlyPublicKey,
  revenueApi,
  invitationApi,
  registerApi,
  myAccountApi,
  universalNavigationApi,
  questionnaireApi,
  hCaptchaSiteKey,
  loginUrl,
  pactSafeAccessId,
  pactSafeGroupId,
  pactSafeGroupKey,
  pactSafeSnapshotId,
  pactSafeUpgradeGroupKey,
  pactSafeUpgradeGroupId,
  pactSafeUpgradeSnapshotId,
};

export default envValues;
